<button *ngIf="!status || isResync" matButton="filled" (click)="onStartSync()">
  <ng-container *ngIf="!status; else reSyncTpl">Start Sync</ng-container>

  <ng-template #reSyncTpl>Re-Sync</ng-template>
</button>
